export const CREATE_PROVISION_BY_SAVED_CARD='CREATE_PROVISION_BY_SAVED_CARD'
export const CREATE_PROVISION_BY_SAVED_CARD_SUCCESS='CREATE_PROVISION_BY_SAVED_CARD_SUCCESS'
export const CREATE_PROVISION_BY_SAVED_CARD_ERROR='CREATE_PROVISION_BY_SAVED_CARD_ERROR'

export const CreateProvisionBySavedCard = (data) => ({
    type: CREATE_PROVISION_BY_SAVED_CARD,
    payload: data
})